import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from './services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {shareReplay} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {StorageService} from './services/storage.service';
import {WebSocketService} from './services/web-socket.service';
import {GridService} from './services/grid.service';
import {ThemeService} from './services/theme.service';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  public user$: Observable<any>;
  public logIn: any;
  title = 'bhs-angular';

  constructor(
    private authService: AuthService,
    private router: Router,
    private storageService: StorageService,
    private webSocketService: WebSocketService,
    private gridService: GridService,
    private themeService: ThemeService,
  ) {
    this.user$ = this.authService.getCurrentUser().pipe(
      shareReplay()
    );
  }

  ngOnDestroy() {
    // this.httpService.get(environment.API_PATH + '/product/stage/edit/bulkStart').subscribe((res: any) => {});
  }

  ngOnInit() {
    this.themeService.init();

    this.logIn = this.authService.currentUserValue;
    this.user$.subscribe(async (resp) => {
      // console.log('resp', resp);
      if (resp) {
        Promise.all([
          this.storageService.getBrands(),
          this.storageService.getTypes(),
          this.storageService.getTags(),
          this.storageService.getShippingTags(),
          this.storageService.getVendorTags(),
        ]).then(() => {
          this.gridService.refreshMetadataCells();
        });
        this.storageService.getUsers();
        this.storageService.getMwsPriceFormula();
        this.webSocketService.connect();

        // let aiResponse = [];
        // do {
          // aiResponse = await this.storageService.getAiCategorisation({
          //   skip: aiResponse.length,
          //   limit: 100000,
          // });
          // console.log('aiResponse', aiResponse);
        // } while (aiResponse.length);

        // this.gridService.updateChangesHistoryCount();
        // this.gridService.updateConflictsHistoryCount();
      }
    });
    // window.location.href = '/grid';
  }
}
